export default __webpack_public_path__ + "static/media/snackFasting.e4adfc7e.svg";